import { ChangeDetectionStrategy, Component } from '@angular/core';
import { SliderComponent, SliderSlideDirective } from '@libs/common/components';
import { ProductCardSkeletonComponent } from '../../../catalog/product-card/product-card-skeleton/product-card-skeleton.component';

@Component({
  selector: 'ui-product-slider-skeleton',
  templateUrl: './product-slider-skeleton.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    ProductCardSkeletonComponent,
    SliderComponent,
    SliderSlideDirective,
  ],
})
export class ProductSliderSkeletonComponent {
  public readonly skeletonArray: number[] = new Array<number>(10).fill(0);
}
